import Button from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";
import { useStyles } from "./Common.styles";

interface LargeActionButtonProps {
	disabled?: boolean;
	variant?: "contained" | "outlined" | "text";
	className?: string;
	sx?: SxProps<Theme>;
	onClick: () => void;
	children: React.ReactNode;
}

export const LargeActionButton = ({
	disabled,
	variant = "contained",
	className,
	sx,
	onClick,
	children,
}: LargeActionButtonProps) => {
	const classes = useStyles();
	const cssClass = className ?? "";

	return (
		<Button
			variant={variant}
			disableRipple
			className={`${classes.customButton} ${cssClass}`}
			onClick={onClick}
			disabled={disabled}
			sx={sx}
			classes={{
				contained: classes.contained,
				outlined: classes.outlined,
			}}
		>
			{children}
		</Button>
	);
};
